import { SettingsActionTypes } from '../types/actions';
import Setting from '../types/Setting';

const defaultSettingsState: Setting[] = [];

export function settingsReducer (state = defaultSettingsState, action: SettingsActionTypes) {
  switch (action.type) {
    case 'SET_SETTINGS':
      return action.settings;
    default:
      return state;
  }
};